module.exports = __webpack_public_path__ + "files/693cc147168da6a0d62c29948e322ecc.png";